import { BidStatus, BidStatusName } from '../../../types/deal.viewmodel.types';

export function bidStatusGetter({ data }): BidStatusName | string {
  const bidStatus: BidStatus = data.bidStatus;

  return BidStatusName[bidStatus] ? BidStatusName[bidStatus] : '';
}
